module.exports = __webpack_public_path__ + "static/media/ms_excel.ea0122d4.svg";